module.exports = "/assets/dist/images/time.svg?881236bac66d9a28958eb4f40fea7382";